import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InformationService {

  constructor() { }

  public domain: string;
  public preferences: any;

  public setVariable(domain: string, preferences: {}): void{
    this.domain = domain;
    this.preferences = preferences[domain];
  }

}
